module.exports = __webpack_public_path__ + "img/AB9_9219.8d53792c.jpg";